import { FolderListComponent } from './folder-list';
import { FolderMatchListComponent } from './folder-match-list';

export const components: any[] = [FolderListComponent, FolderMatchListComponent];

export * from './folder-list';
export * from './folder-match-list';
